import './contact-view-layout.component.ajs.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './contact-view-layout.component.ajs.html';

const MODULE_NAME = 'contactViewLayout';

class ContactViewLayoutCtrl implements IComponentController {
  public name = MODULE_NAME;

  respondeId: string;

  constructor(private readonly $transcule: any) {}

  $onInit() {}

  hasTransclude(transcludeName: string) {
    return this.$transcule.isSlotFilled(transcludeName);
  }
}

export class ContactViewLayout implements IComponentOptions {
  templateUrl = templateUrl;
  transclude = {
    actionsRef: '?actionsRef',
    workspaceRef: '?workspaceRef',
  };
  bindings = {
    respondeId: '<',
  } as { [binding: string]: string };
  controller = ['$transclude', ContactViewLayoutCtrl];
}

export default MODULE_NAME;
